// Row of small stat tiles (label + value) summarizing a delivery run, shown on the Complete phase.
import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { tokens } from "../../theme";

const TripStatTiles = ({ stats }) => {
  if (!stats?.length) return null;
  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {stats.map((stat, i) => (
        <Box
          key={`${stat.label}-${i}`}
          sx={{
            flex: "1 1 100px",
            minWidth: 100,
            p: 1.25,
            background: tokens.surface2,
            border: `1px solid ${tokens.border}`,
            borderRadius: "10px",
          }}
        >
          <Typography
            sx={{
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.06em",
              color: tokens.text3,
              textTransform: "uppercase",
            }}
          >
            {stat.label}
          </Typography>
          <Typography
            sx={{
              fontSize: 17,
              fontWeight: 700,
              letterSpacing: "-0.01em",
              color: stat.color || tokens.text,
              mt: 0.3,
            }}
          >
            {stat.value}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

TripStatTiles.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node,
      color: PropTypes.string,
    })
  ),
};

export default TripStatTiles;
